import React from 'react';
import './styles/DesignerStyles.css';
import Home from './Home';
import JoinRoom from './JoinRoom';
import CreateGame from './CreateGame';
import TeamAndWords from './TeamAndWords';
import Lobby from './Lobby';
import Game from './Game';
import RoundCompleted from './RoundCompleted';
import Info from './Info';
import Rules from './Rules';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import Verification from './Verification';
import SignUp from './SignUp';
import LoginJustGoogle from './LoginJustGoogle';
import Profile from './Profile';
import QRCodePage from './QRCodePage';
import PrivacyPolicy from './PrivacyPolicy';

import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import TermsOfService from './TermsOfService';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Routes>
        <Route
          path="/Login"
          element={
            <Login
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/Profile"
          element={
            <Profile
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/PrivacyPolicy"
          element={
            <PrivacyPolicy
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/TermsOfSercice"
          element={
            <TermsOfService
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/LoginJustGoogle"
          element={
            <LoginJustGoogle
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/Rules"
          element={
            <Rules
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/SignUp"
          element={
            <SignUp
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/ForgotPassword"
          element={
            <ForgotPassword
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/Verification"
          element={
            <Verification
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/"
          element={
            <Home
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/JoinRoom"
          element={
            <JoinRoom
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/CreateGame"
          element={
            <CreateGame
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/TeamAndWords/:id"
          element={
            <TeamAndWords
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/Lobby/:id"
          element={
            <Lobby
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/QRCodePage/:id"
          element={
            <QRCodePage
              navigate={this.props.navigate}
              location={this.props.location}
            />
          }
        />
        <Route
          path="/game/:id"
          element={
            <Game
              navigate={this.props.navigate}
              location={this.props.location}></Game>
          }
        />
        <Route
          path="/RoundCompleted/:id"
          element={
            <RoundCompleted
              navigate={this.props.navigate}
              location={this.props.location}></RoundCompleted>
          }
        />
        <Route
          path="/Info/:id"
          element={
            <Info
              navigate={this.props.navigate}
              location={this.props.location}></Info>
          }
        />
      </Routes>
    );
  }
}

export function AppWithRouter(props) {
  const navigate = useNavigate();
  const location = useLocation();

  return <App location={location} navigate={navigate}></App>;
}
